import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import './index.scss'
import UserAvatar from '../../../components/Shared/UserAvatar'

export default ({ inProfile, user, userRole }) => (
  <div className='account-card round-corner'>
    <p className='head'>
      {inProfile ? 'Account' : 'User'} Details
    </p>
    <div className='avatar'>
      <UserAvatar user={user} style={{lineHeight: '150px'}}/>
      {/* <Upload className='avatar-upload'>
        <Icon type='edit' />  Change
      </Upload> */}
    </div>
    <p className='name'>{user.first_name + ' ' + user.last_name}</p>
    <p className='email'>{user.email}</p>
    {!inProfile &&
      <p className='activation_date'>
        Active since {moment(user.activation_date).format('MM/DD/YYYY')}
      </p>
    }
    {inProfile ?
      <div className='links'>
        <Link to='/profile/edit'> Edit Account Details </Link>
        <Link to='/profile/changepassword'> Change Password </Link>
      </div>
      :
      <div className="role">
        {userRole}
      </div>
    }
  </div>
)
